import { useState } from "react";
import useDeleteData from "../../../hooks/useDeleteData";
import { ViewMoreIcon } from "../../../assets/icons";
import { GetAccess } from "../../../utils/RolesandAccess";
import CreateorUpdate from "./form";
import { ViewRoles } from "./viewRoles";

function Viewmore({ fetcher, data }) {
  const { handleDelete } = useDeleteData();
  const [showMyModal, setShowMyModal] = useState(false);
  const handleOnClose = () => setShowMyModal(false);
  const [showFile, setShowFile] = useState(false);
  const handleClose = () => setShowFile(false);

  return (
    <>
        <div className="hover:drop-shadow-sm mr-2 py-2 px-[14px] rounded-3xl bg-white dropdown cursor-pointer relative">
      <ViewMoreIcon />
      <div className="hidden dropdown-menu">
        <div
          id="modal"
          className="bg-transparent fixed inset-0 flex justify-center items-center "
        ></div>
        <div className="bg-white rounded-xl w-20 absolute -left-20 -top-1">
          <div className="grid p-1 rounded-t">
            <span
              className="p-1 hover:bg-navhover hover:rounded-lg text-xs"
              onClick={() => setShowFile(true)}
            >
              View
            </span>
            {GetAccess("admin_edit") && (
              <span
                className="p-1 text-xs hover:bg-navhover hover:rounded-lg cursor-pointer"
                onClick={() => setShowMyModal(true)}
              >
                Edit
              </span>
            )}
            {GetAccess("admin_delete") && (
              <span
                className="p-1 text-xs hover:bg-navhover hover:rounded-lg"
                onClick={() => {
                  handleDelete({
                    url: `/Role/${data?.roleId}`,
                    id: data?.roleId,
                    value: data?.roleName,
                    fetcher:fetcher
                  });
                }}
              >
                Delete
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
    <CreateorUpdate onClose={handleOnClose} visible={showMyModal} data={data} refreshData={fetcher} />
    <ViewRoles data={data} onClose={handleClose} visible={showFile}/>

    </>
  );
}

export default Viewmore;
